import { CrudService } from '../base/CrudService';
export class RequestPurchaseOrderService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestPurchaseOrderService.DEFAULT_SERVICE_PATH,
            basePath: RequestPurchaseOrderService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RequestPurchaseOrderService.DEFAULT_SERVICE_PATH = 'procurements';
RequestPurchaseOrderService.BASE_PATH = 'api/requestpurchaseorder';
//# sourceMappingURL=RequestPurchaseOrderService.js.map